import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

type LoadingIndicatorProps = {
  visible: boolean;
};

export const LoadingIndicator = ({ visible }: LoadingIndicatorProps) => {
  const { t } = useTranslation();

  if (!visible) return null;

  return (
    <Stack direction="row" spacing={0.25}>
      <Typography sx={{ color: 'text.primary', fontSize: 13 }}>
        {t('Finding the best inventory based on your prompt')}
      </Typography>
      <Typography sx={{ color: 'text.primary', fontSize: 13 }}>...</Typography>
    </Stack>
  );
};
